import { useState, useEffect } from "react";
import { OutlinedButton } from "@components/atoms/base-button";
import { Link } from "@shopify/hydrogen";
import { translate } from "@locales";

export const CookiePopover = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const isAccepted = localStorage.getItem("cookieAccepted");
    if (!isAccepted) {
      setIsOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieAccepted", "true");
    setIsOpen(false);
  };

  return (
    <>
      {isOpen && (
        <div className="border-y-[2px] fixed bottom-0 z-50 w-full bg-white shadow-lg pointer-events-auto">
          <div className="flex w-full justify-center py-4 md:py-8">
            <div className="w-full px-4 sm:px-6 md:px-28">
              <div className="w-full font-chivo-regular flex flex-col sm:flex-row sm:items-center space-y-4 sm:space-y-0 sm:space-x-[270px]">
                <p className="w-full text-sm text-start md:text-start sm:w-auto sm:text-center">
                  {translate("cookies.info.0")}{" "}
                  <span className="font-chivo-bold">
                    {translate("cookies.info.1")}
                  </span>{" "}
                  {translate("cookies.info.2")}{" "}
                  <Link
                    className="text-custom-dark-blue underline font-chivo-bold"
                    to="/privacy-policy"
                  >
                    {translate("cookies.learn-more")}
                  </Link>
                </p>
                <div>

                <OutlinedButton
                  onClick={handleAccept}
                  className="w-full sm:w-[190px] text-lg h-11"
                >
                  {translate("cookies.got-it")}
                </OutlinedButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
